<template>
  <div class="collapse">
    <div
      class="hd"
      :class="{
        fold: !configMainShow['duty'],
      }"
      @click="configMainShow['duty'] = !configMainShow['duty']"
    >
      <div class="title-fix">
        <i class="fa-angle-down"></i>
        <span>下播值守</span>
        <span class="el-switch" @click.stop="toggleEnable('duty', '下播值守')">
          <el-switch v-model="configure.duty.enable" disabled></el-switch>
        </span>
      </div>
    </div>
    <div
      class="bd"
      @click="
        isNaN(featureList['duty'].timeRemaining)
          ? shoWDialogBuy(featureList['duty']['productKey'], '下播值守', 'duty')
          : featureList['duty'].timeRemaining <= 0
          ? showFunctionalRenewal(true)
          : configure.duty.enable
          ? ''
          : toggleEnable('duty', '下播值守')
      "
      :class="{
        'no-buy': isNaN(featureList['duty'].timeRemaining),
        expired: featureList['duty'].timeRemaining <= 0,
        'shut-off': !configure.duty.enable,
      }"
    >
      <el-row>
        <el-col :span="5">值守功能</el-col>
        <el-col :span="19">
          <div class="block-tag">
            主播下播后，机器人依然值守工作，可以设置需要开启的功能。这个功能比较开销小虎弟的服务器，有需要的用户可以选择购买开启。
          </div>
          <el-row>
            <el-col :span="12">
              <el-switch v-model="configure.duty.welcome"></el-switch>来宾欢迎
            </el-col>
            <el-col :span="12">
              <el-switch v-model="configure.duty.giftTks"></el-switch>礼物答谢
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-switch v-model="configure.duty.guide"></el-switch>定时引导
            </el-col>
            <el-col :span="12">
              <el-switch v-model="configure.duty.autoReply"></el-switch>智能答复
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-switch v-model="configure.duty.AIChat"></el-switch>AI 互动
            </el-col>
            <el-col :span="12">
              <el-switch v-model="configure.duty.autoBan"></el-switch>自动封禁
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-switch v-model="configure.duty.keyPerson"></el-switch>大哥名单
            </el-col>
            <el-col :span="12"></el-col>
          </el-row>
          <!-- 需要判断有没有购买 -->
          <el-row>
            <el-col
              :span="12"
              v-if="!isNaN(featureList['guessProvince'].timeRemaining)"
            >
              <el-switch v-model="configure.duty.guessProvince"></el-switch
              >猜省会
            </el-col>
            <el-col
              :span="12"
              v-if="!isNaN(featureList['guessNum'].timeRemaining)"
            >
              <el-switch v-model="configure.duty.guessNum"></el-switch>猜点数
            </el-col>
          </el-row>
          <el-row>
            <el-col
              :span="12"
              v-if="!isNaN(featureList['privateLetter'].timeRemaining)"
            >
              <el-switch v-model="configure.duty.privateLetter"></el-switch>私信
            </el-col>
            <el-col :span="12"> </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">下播引导</el-col>
        <el-col :span="19">
          <div class="sentence-list">
            <div class="block-tag">
              下播后，可引导用户去看自己的社交媒体看短视频、微博等。
            </div>
            <ul>
              <li v-for="(item, index) in configure.duty.guideTpl" :key="index">
                <Editor
                  v-model="configure.duty.guideTpl[index]"
                  :labels="['anchorNick']"
                  @input="checkEmpty(configure.duty.guideTpl, index)"
                ></Editor>
                <i
                  class="fa-window-close"
                  @click="removeDutyGuideTpl(index)"
                ></i>
              </li>
            </ul>
          </div>
          <div
            class="sentence-add"
            tabindex="99"
            @focusin="eleFocusIn('addDutyGuide')"
            @focusout="singleInputFocusOut('addDutyGuide')"
          >
            <Editor
              v-model.trim="addDutyGuide"
              mode="edit"
              :labels="['anchorNick']"
            ></Editor>
            <el-popover
              ref="addDutyGuide"
              placement="bottom-end"
              width="280"
              v-model="isShowInputBlurTips.addDutyGuide"
              trigger="manual"
              :popper-options="{
                boundariesElement: 'body',
                adaptive: false,
              }"
            >
              <p>记得点“添加句子”才会生效哦</p>
            </el-popover>
            <el-button
              size="small"
              @click="addDutyGuideTpl"
              v-popover:addDutyGuide
              >添加句子</el-button
            >
          </div>
          <q
            >有填下播引导，则下播后，定时引导的内容优先调用下播引导；若不填，则读取定时引导内容</q
          >
        </el-col>
      </el-row>
      <div class="reset-row">
        <el-button
          type="danger"
          size="small"
          @click="resetDefault('下播值守', 'duty')"
          >「下播值守」恢复默认</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { configCommon } from "@/mixins/configCommon";
import { commonFuc } from "@/mixins/commonFuc";
export default {
  mixins: [configCommon, commonFuc],
  data() {
    return {
      addDutyGuide: "", // 下播引导 句式输入框
    };
  },
  props: {
    configure: {
      type: Object,
      default: null,
    },
    featureList: {
      type: Object,
      default: null,
    },
    configMainShow: {
      type: Object,
      default: () => {
        return {
          account: true,
          welcome: true,
          giftTks: true,
          guide: true,
          autoReply: true,
          AIChat: true,
          readText: true,
          autoBan: true,
          keyPerson: true,
          begGift: true,
          guessNum: true,
          duty: true,
          global: true,
        };
      },
    },
  },
  mounted() {},
  methods: {
    removeDutyGuideTpl(index) {
      this.configure.duty.guideTpl.splice(index, 1);
      this.$message.success("删除成功");
    }, // 删除下播引导句式
    addDutyGuideTpl() {
      if (this.addDutyGuide === "") {
        this.$message.warning("不能为空哦");
      } else {
        this.configure.duty.guideTpl.unshift(this.addDutyGuide);
        this.$message.success("添加成功");
        this.addDutyGuide = "";
      }
    }, //  下播引导句式添加
  },
};
</script>
